import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { post } from "../../../helpers/api_helper";

import {
  POST_GetEmailTypeList,
  POST_GetInstanceTypeList,
  POST_InstanceTypeListInsert,
} from "../../../helpers/url_helper";
import { errorMessage, successMessage } from "../CommonFunctions";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";

const EmailConfiguration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [emailTypeList, setEmailTypeList] = useState([]);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ListOfInstanceType: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfInstanceType },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      ListOfInstanceType: values?.ListOfInstanceType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_InstanceTypeListInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    get_EmailType();
    getEmailConfigurationList();
  }, []);

  const get_EmailType = async () => {
    setIsLoading(true);
    await post(POST_GetEmailTypeList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmailTypeList(
            response?.List?.map((item) => ({
              label: item.EmailTypeName,
              value: item.EmailConfigurationIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmailConfigurationList = async () => {
    setIsLoading(true);

    await post(POST_GetInstanceTypeList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInstanceType",
            response?.ListOfInstanceType
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const shouldHideRow = (AuthUser, item) => {
    if (AuthUser?.Permissions?.Account !== 1) {
      // Hide for specific InstanceTypes
      const hiddenInstanceTypes = [6, 7, 8, 13]; // 6 - Performa Invoice, 7 - Invoice, 8 - Credit Note, 13 - Machine Calibration Validity Expire
      if (hiddenInstanceTypes.includes(item?.InstanceType)) {
        return true;
      }
    }

    if (AuthUser?.Permissions?.DispatchMaterial !== 1) {
      if (item?.InstanceType === 5) {
        //5-Dispatch Material
        return true;
      }
    }

    return false; // Show the row
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="active-projects style-1">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Email Configuration</h4>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="dashboard-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer"
                          style={{ height: "700px", overflowY: "auto" }}
                        >
                          <table
                            id="dashboard-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="3%">Email</th>
                                <th style={{ display: "none" }} width="3%">
                                  WhatsApp
                                </th>
                                <th width="12%">Instance</th>
                                <th width="10%">Send To</th>
                                <th width="15%">Email Type</th>
                                <th width="35%">Subject</th>
                                <th width="25%" style={{ textAlign: "left" }}>
                                  Additional Recipient(CSV)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfInstanceType?.length > 0 ? (
                                ListOfInstanceType?.map((item, indx) => (
                                  <tr
                                    key={indx}
                                    style={{
                                      display: shouldHideRow(AuthUser, item)
                                        ? "none"
                                        : "",
                                    }}
                                  >
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsEmail${indx}`}
                                        name={`chkIsEmail${indx}`}
                                        checked={item?.IsEmail}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfInstanceType[${indx}].IsEmail`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        display: "none",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsWhatsApp${indx}`}
                                        name={`chkIsWhatsApp${indx}`}
                                        checked={item.IsWhatsApp}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfInstanceType[${indx}].IsWhatsApp`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{item?.Instance}</td>
                                    <td>{item?.SendTo}</td>
                                    <td>
                                      <Field
                                        name={`ListOfInstanceType[${indx}].EmailConfigurationIDEncrypted`}
                                        placeholder={"Email Type"}
                                        options={emailTypeList}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        isClearable={false}
                                      />
                                    </td>
                                    <td className="d-items p-1">
                                      <Field
                                        type="text"
                                        name={`ListOfInstanceType.[${indx}].Subject`}
                                        component={CustomInput}
                                        placeholder="Subject"
                                        noMarginBottom={true}
                                        disabled={true}
                                      />
                                    </td>
                                    <td className="d-items p-1">
                                      <Field
                                        type="text"
                                        name={`ListOfInstanceType.[${indx}].AdditionalRecipientEmailID`}
                                        component={CustomInput}
                                        placeholder="Additional Recipient Email"
                                        noMarginBottom={true}
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={8}
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    <div>{"No options"}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default EmailConfiguration;
